import React from 'react';
import { useLocation } from 'react-router-dom';
import { AdUnit, adsAllowed } from './AdUnit';

const SLOTS = {
  listing: process.env.REACT_APP_ADSENSE_SLOT_LISTING,
  detail: process.env.REACT_APP_ADSENSE_SLOT_DETAIL,
  content: process.env.REACT_APP_ADSENSE_SLOT_CONTENT,
  dashboard: process.env.REACT_APP_ADSENSE_SLOT_DASHBOARD
};

/**
 * A labelled, clearly separated ad block. Renders nothing unless AdSense is configured,
 * the viewer is not a staff member and the host page has enough real content.
 */
export const AdSlot = ({ slot, enoughContent = true, label = 'Advertisement', className = '', format = 'auto', layoutKey }) => {
  const location = useLocation();
  if (!enoughContent || !adsAllowed() || !SLOTS[slot]) return null;

  return (
    <aside
      className={`my-8 max-w-full overflow-hidden rounded-xl border border-slate-200/70 bg-slate-50/60 px-3 pb-3 pt-2 ${className}`}
      aria-label={label}
      data-testid={`ad-slot-${slot}`}
    >
      <p className="mb-2 text-[10px] uppercase tracking-[0.18em] text-slate-400">{label}</p>
      <AdUnit
        key={`${slot}-${location.pathname}${location.search}`}
        slot={SLOTS[slot]}
        format={format}
        layoutKey={layoutKey}
      />
    </aside>
  );
};
